import {
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  CUSTOM_ELEMENTS_SCHEMA,
  OnInit,
  TemplateRef,
  ViewChild,
} from '@angular/core';
import { InternetService } from './shared/services/shared/internet/internet.service';
import { SpinnerService } from './shared/services/shared/spinner/spinner.service';
import { SharedUserService } from './shared/services/shared/user/shared-user.service';
import { finalize, Subscription } from 'rxjs';
import { SharedProgressBarService } from './shared/services/shared/progress-bar/shared-progress-bar.service';
import { ApplicationDetailService } from './shared/services/transactional/application-detail/application-detail.service';

import {
  NgbCarouselModule,
  NgbDropdownModule,
  NgbModal,
  NgbModalRef,
  NgbModule,
} from '@ng-bootstrap/ng-bootstrap';

import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { environment } from '../environments/environment';
import { Meta } from '@angular/platform-browser';
import { Inject, PLATFORM_ID } from '@angular/core';
import { CommonModule, isPlatformBrowser } from '@angular/common';
import { RouterOutlet } from '@angular/router';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgxSpinnerModule } from 'ngx-spinner';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { ToastControlComponent } from './shared/controls/toast-control/toast-control.component';
import { GoogleTrackingService } from './shared/services/transactional/google-tracking/google-tracking.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
  standalone: true,
  schemas: [CUSTOM_ELEMENTS_SCHEMA],

  imports: [
    CommonModule,
    RouterOutlet,
    FormsModule,
    ReactiveFormsModule,

    NgbModule,
    NgbDropdownModule,
    NgbCarouselModule,
    NgxSpinnerModule,
    FontAwesomeModule,
    TranslateModule,
    ToastControlComponent,
  ],
})
export class AppComponent implements OnInit, AfterViewInit {
  public showProgressbar: boolean = false;
  public name: string = null!;
  public spinnerText: string = null!;
  public isLoading: boolean = false;
  public isAppLoading: boolean = true;

  @ViewChild('updateAvailableModal')
  public updateAvailableModal: TemplateRef<any> = null!;
  private _subscriptions: Subscription[] = [];

  //Check
  constructor(
    @Inject(PLATFORM_ID) private platformId: Object,
    private _internetService: InternetService,
    private _spinnerService: SpinnerService,
    private _sharedUserService: SharedUserService,
    private _sharedProgressBarService: SharedProgressBarService,
    private _applicationDetailService: ApplicationDetailService,
    private _translateService: TranslateService,
    private meta: Meta,
    private _changeDetectorRef: ChangeDetectorRef,
    private _googleTracking: GoogleTrackingService,
  ) {}

  public ngOnInit() {
    if (this.isBrowser()) {
      this._googleTracking.init();

      this._subscribeInternetService();
      this._subscribeSpinnerService();
      this._subscribeUserService();
      this.loadApplicationDetail();

      const lang = localStorage.getItem('language') || 'en';
      this._translateService.use(lang);
    }

    this.subscribeOrganizationProgressbarService();

    if (environment.blockRobots) {
      this.meta.addTag({
        name: 'robots',
        content: 'noindex, nofollow',
      });
    }
    console.log(`App Version`);
  }

  private isBrowser(): boolean {
    return isPlatformBrowser(this.platformId);
  }

  private injectGoogleTag(): void {
    if (!this.isBrowser()) return;

    if (
      environment.production &&
      environment.googleAdsId &&
      environment.googleAdsId.length > 0
    ) {
      const script1 = document.createElement('script');
      script1.id = 'google-gtag';

      script1.async = true;
      script1.src = `https://www.googletagmanager.com/gtag/js?id=${environment.googleAdsId}`;
      document.head.appendChild(script1);

      const script2 = document.createElement('script');
      script2.innerHTML = `
      window.dataLayer = window.dataLayer || [];
      function gtag(){dataLayer.push(arguments);}
      gtag('js', new Date());
      gtag('config', '${environment.googleAdsId}');
    `;
      document.head.appendChild(script2);
    }
  }

  public async ngAfterViewInit() {
    if (!this.isBrowser()) {
      return;
    }
  }

  private loadApplicationDetail(): void {
    this._spinnerService.show('Loading ClockFlex...');
    this._changeDetectorRef.detectChanges();

    this._applicationDetailService
      .getVersion()
      .pipe(
        finalize(() => {
          this._changeDetectorRef.detectChanges();
        }),
      )
      .subscribe({
        next: (response) => {
          if (response.isSuccess) {
            if (response.data) {
              let version: string | null = localStorage.getItem(
                'application_version',
              );

              if (version != response.data) {
                localStorage.setItem('application_version', response.data);
                // this._router.navigate(['../auth/login']);
                localStorage.removeItem('loggedIn');
              }
            }
          }
          this._spinnerService.hide();
          this.isAppLoading = false;
          this._changeDetectorRef.detectChanges();
        },
      });
  }

  private _subscribeInternetService(): void {
    this._internetService.subscribeInternetEvents();
  }

  public _subscribeSpinnerService(): void {
    let sub = this._spinnerService.spinnerText$.subscribe(
      (text) => (this.spinnerText = text),
    );
    this._subscriptions.push(sub);
  }

  public ngOnDestroy(): void {
    this._internetService.unsubscribeInternetEvents();
    this._subscriptions.forEach((s) => s.unsubscribe());
  }

  private _subscribeUserService(): void {
    this._sharedUserService.get();
  }

  private subscribeOrganizationProgressbarService(): void {
    let sub =
      this._sharedProgressBarService.isOrganizationProgressbarLoading$.subscribe(
        (response) => {
          this.isLoading = response;
        },
      );
    this._subscriptions.push(sub);
  }
}
